module.exports = __webpack_public_path__ + "static/media/child2-cta.8f29244a.png";